import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import { auth, commonStore, betsStore, accountStore, fantasyCricketStore, walletStore, mutations, actions } from '@template/utils';

export default createStore({
  state: {},
  mutations,
  actions,
  modules: { auth, commonStore, betsStore, accountStore, fantasyCricketStore, walletStore },
  plugins: [createPersistedState({
    key:'sd:site'
  })]
});